import type { Listing } from '@thevillages/schemas';

import { Component, computed, input } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-home-listing-card-features',
  templateUrl: './features.html',
})
export class HomeListingCardFeatures {
  public readonly listing = input.required<Listing>();

  protected readonly certified = computed(() => this.listing().certified);
  protected readonly furnished = computed(() => this.listing().furnished);
  protected readonly furnitureAvailable = computed(() => this.listing().furnitureAvailable);
  protected readonly partiallyFurnished = computed(() => this.listing().partiallyFurnished);
  protected readonly pending = computed(() => this.listing().pending);
  protected readonly staged = computed(() => this.listing().listingStatus === 'staged');
  protected readonly turnkey = computed(() => this.listing().turnkey);
}
